import {
  Button,
  Container,
  DialogActions,
  Grid,
  Paper,
} from "@material-ui/core";
import FormBuilder from "../../../components/form-builder";
import * as Yup from "yup";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import appService from "../../../services/app.service";
import { useErrorHandler } from "../../../hooks";
import { useSnackbar } from "notistack";

const formWrapper = (props) => <Grid container spacing={2} {...props} />;

const form = [
  {
    _type: "textField",
    _wrapper: (props) => <Grid item xs={12} sm={4} {...props} />,
    name: "coordinationExpDays",
    label: "روزهای قابل قبول برای هماهنگی",
    type: "number",
  },
  {
    _type: "textField",
    _wrapper: (props) => <Grid item xs={12} sm={4} {...props} />,
    name: "dailyCoordinationRequest",
    label: "تعداد درخواست هماهنگی در روز",
    type: "number",
  },
  {
    _type: "textField",
    _wrapper: (props) => <Grid item xs={12} sm={4} {...props} />,
    name: "monthlyCoordinationRequest",
    label: "تعداد درخواست هماهنگی در ماه",
    type: "number",
  },
  {
    _type: "textField",
    _wrapper: (props) => <Grid item xs={12} sm={4} {...props} />,
    name: "webappDiscount",
    label: "تخفیف با نصب برنامه",
    type: "number",
    inputProps: {
        min: 0,
        max: 100,
      },
  },
  {
    _type: "textField",
    _wrapper: (props) => <Grid item xs={12} {...props} />,
    name: "termsOfServices",
    label: "قوانین و مقررات",
    multiline: true,
    rows: 6,
  },
  {
    _type: "textField",
    _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
    name: "telephone",
    label: "شماره تماس",
    placeholder: "+989123456789",
    inputProps: { className: "en text-center" },
  },
  {
    _type: "textField",
    _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
    name: "messageUrl",
    label: "لینک پیام",
    placeholder: "https://wa.me/09122222222",
    inputProps: { className: "en" },
  },
  {
    _type: "textField",
    _wrapper: (props) => <Grid item xs={12} sm={12} {...props} />,
    name: "address",
    label: "آدرس",
    placeholder: "آدرس",
  },
  // {
  //   _type: "array",
  //   _wrapper: (props) => <Grid item xs={12} {...props} />,
  //   _itemsWrapper: (props) => (
  //     <Grid item xs>
  //       <Grid container spacing={2} {...props} />
  //     </Grid>
  //   ),
  //   name: "phoneNumbers",
  //   label: "تلفن‌های تماس",
  //   minLength: 1,
  //   dense: true,
  //   emptyValue: {
  //     title: "",
  //     value: "",
  //   },
  //   items: [
  //     {
  //       _type: "textField",
  //       _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
  //       name: "title",
  //       label: "عنوان",
  //     },
  //     {
  //       _type: "textField",
  //       _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
  //       name: "value",
  //       label: "شماره",
  //     },
  //   ],
  // },
];
const schema = Yup.object().shape({});

export function SettingsPage() {
  const { initials } = useSelector((s) => s.app);
  const errorHandler = useErrorHandler();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = useMemo(() => {
    const {
      coordinationExpDays = 14,
      dailyCoordinationRequest = 10,
      monthlyCoordinationRequest = 30,
      webappDiscount = 0,
      termsOfServices = "",
      // phoneNumbers = [{ title: "", value: "" }],
      messageUrl = "",
      address = "",
      telephone = "",
    } = initials || {};
    return {
      coordinationExpDays,
      dailyCoordinationRequest,
      monthlyCoordinationRequest,
      webappDiscount,
      termsOfServices,
      messageUrl,
      address,
      telephone,
      // phoneNumbers,
    };
  }, [initials]);

  async function handleSubmit(values, helpers) {
    const { error } = await appService.updateMetadata(values);
    if (error) {
      return errorHandler();
    }
    enqueueSnackbar("عملیات با موفقیت انجام شد.", { variant: "success" });
    helpers.resetForm({ values });
    appService.getInitials();
  }
  return (
    <Container>
      <Paper className="my-2 p-2">
        <FormBuilder
          schema={schema}
          initialValues={initialValues}
          handleSubmit={handleSubmit}
          form={form}
          actionComponent={({ isSubmitting, resetForm, dirty }) => (
            <DialogActions>
              {dirty && (
                <Button
                  onClick={resetForm}
                  color="primary"
                  disabled={isSubmitting}
                >
                  لغو
                </Button>
              )}
              <Button
                type="submit"
                disabled={isSubmitting || !dirty}
                variant="contained"
                color="primary"
              >
                ذخیره
              </Button>
            </DialogActions>
          )}
          formWrapper={formWrapper}
        />
      </Paper>
    </Container>
  );
}
